import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SimpleHttpRequest {

    constructor(private http: HttpClient) { }

    getRequest(url) {
        return this.http.get(url);
    }
}
